export class filedata {
    filename: string | undefined;
    url: string | undefined;
    size: number | undefined;
}